import css from "../Queues.module.css";

import { useCallback, useEffect, useState } from "react";
import Client from "../../../../components/distributed_systems/Client/Client";
import Server from "../../../../components/distributed_systems/Server/Server";
import System from "../../../../components/distributed_systems/System/System";
import Track from "../../../../components/distributed_systems/Track/Track";
import { v4 as uuid } from "uuid";

const NoQueue = ({ isPlaying }) => {
  const [requests, setRequests] = useState([]);
  const [history, setHistory] = useState([]);

  const sendRequest = (settings) => {
    const request = {
      id: uuid(),
      createdAt: Date.now(),
      loadSize: 2,
      status: "client-server",
      networkSpeed: 1000,
    };

    setRequests((old) => {
      const newRequests = [...old, request];
      return newRequests;
    });
  };

  useEffect(() => {
    if (!isPlaying) return;
    const intervalId = setInterval(() => {
      sendRequest();
    }, 500);
    return () => clearInterval(intervalId);
  }, [isPlaying]);

  const removeRequest = useCallback((request) => {
    setRequests((old) => old.filter((r) => r.id !== request.id));
    setHistory((old) => [...old, request]);
  }, []);

  const queryServer = useCallback((request) => {
    setRequests((old) => {
      const isAvailable = !old.some((r) => r.status === "server-processing");

      const index = old.findIndex((req) => req.id === request.id);
      if (index === -1) return old;

      const newRequests = [...old];
      newRequests[index] = {
        ...newRequests[index],
        status: isAvailable ? "server-processing" : "server-rejected",
      };

      return newRequests;
    });
  }, []);

  const serveRequest = useCallback(async (request) => {
    setRequests((old) => {
      const index = old.findIndex((req) => req.id === request.id);
      if (index === -1) return old;

      const newRequests = [...old];
      newRequests[index] = {
        ...newRequests[index],
        status: "server-processed",
      };

      return newRequests;
    });
  }, []);

  const processed = history.filter(
    (req) => req.status === "server-processed",
  ).length;
  const rejected = history.filter(
    (req) => req.status === "server-rejected",
  ).length;

  return (
    <div className={css.demo}>
      <i>NO QUEUE</i>

      <System>
        <Client onClick={sendRequest} type="mobile" />
        <Track
          requests={requests}
          onComplete={queryServer}
          statuses={["client-server", "server-rejected"]}
          removeRequest={removeRequest}
        />
        <Server
          request={
            requests.filter(
              (request) => request.status === "server-processing",
            )[0]
          }
          onComplete={serveRequest}
        />
        <Track
          requests={requests}
          onComplete={removeRequest}
          statuses={["server-processed"]}
          removeRequest={removeRequest}
        />
      </System>
      <div className={css.info}>
        <div className={css.stats_bar}>
          <div
            className={css.stat_bar_accepted}
            style={{ width: `${(processed / history.length || 0.5) * 100}%` }}
          />
        </div>
        <div className={css.stat_labels}>
          <div className={css.stat}>
            <div
              className={`${css.stat_icon_container} ${css.stat_icon_container_accepted}`}
            >
              <img
                className={css.stat_icon}
                src="https://storage.googleapis.com/squidslippers-media/icons/check.png"
                alt="check"
              />
            </div>
            <strong className={css.stat_number}>
              {Math.round((processed / (processed + rejected)) * 100) || 0}
              <span className={css.percent}>%</span>
            </strong>
          </div>
          <div className={css.stat}>
            <strong className={css.stat_number}>
              <span className={css.percent}>%</span>
              {Math.round((rejected / (processed + rejected)) * 100) || 0}
            </strong>
            <div
              className={`${css.stat_icon_container} ${css.stat_icon_container_rejected}`}
            >
              <img
                className={css.stat_icon}
                src="https://storage.googleapis.com/squidslippers-media/icons/x.png"
                alt="check"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoQueue;
